import React from 'react';
import logo from '../assets/connect-plus-icon.png';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';

const Header: React.FC = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  const displayName =
    auth.user?.profile?.name ||
    (auth.user?.profile?.preferred_username as string | undefined) ||
    'Gebruiker';

  const handleLogout = async (): Promise<void> => {
    try {
      await auth.signoutRedirect();
      navigate('/');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <header className="w-full bg-neutral-100 border-b border-primary-600">
      <div className="max-w-7xl mx-auto py-4 flex items-center justify-between px-8 xl:px-0">
        <div className="flex items-center gap-4">
          <img src={logo} alt="Company logo" className="h-10 w-10 object-contain" />
          <div className="text-lg font-semibold text-neutral-900">Athena</div>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-primary-600 text-white flex items-center justify-center text-sm font-semibold">
              {displayName.charAt(0).toUpperCase()}
            </div>
            <span className="text-sm text-neutral-700 hidden sm:inline">
              {displayName}
            </span>
          </div>
          <button
            onClick={handleLogout}
            className="px-3 py-1.5 text-sm text-neutral-600 hover:text-neutral-900 border border-neutral-300 rounded-lg hover:bg-neutral-100 transition-colors flex items-center gap-1.5"
          >
            <i className="fa-light fa-arrow-right-from-bracket" />
            Afmelden
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
